export default __webpack_public_path__ + "static/media/youtube.d5147516.svg";